<template>
<div class="home-main">
    <div class="content">
      <div class="world" ref="world">
        <div class="world-title" v-show="viewportWidth <= 799">
          No rush, just the end of the world
        </div>
         <div class="world-content">
          <div class="world-desc">We specialize in China travel trips and help you gain insight into China's niche landscapes.</div>
        </div>
        <img loading="lazy" :src="viewportWidth <= 799 ? RectanglePhone : Rectangle" alt="" :class="{'animate':isWorldAnimate,'banner-fade-in':isWorldAnimate}">
      </div>
      <div class="experiences">
        <div class="experiences-title">Exclusive Travel Experiences</div>
        <div class="experiences-desc">Time and place are everything, carefully designing the experience at each destination.</div>
        <div class="experiences-content" ref="experiences">
        <div class="experiences-content-item" v-for="item in experiencesList" :key="item.id" @click="experiencesEvent(item.id)">
            <img loading="lazy"  :src="item.img" alt="" :class="{'banner-fade-in':isExperiencesAnimate}">
            <div class="bottom" :class="{'animate':isExperiencesAnimate}">
              <div class="experiences-content-item-title">{{item.title}}</div>
              <div class="experiences-content-item-desc">{{item.desc}}</div>
              <div class="experiences-content-item-btn">{{item.btn}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Popular-products" ref="popularProducts"> 
        <div class="Popular-products-center" :style="{'display': isAnimateX ? 'block' : 'none'}">
          <div class="Popular-products-title">Popular Products</div>
          <div class="Popular-products-content">
            <div class="Popular-products-item" 
            v-for="(item,index) in productsList" 
            :key="item.id"
            @click="productDetilsEvent(item.id)"
            :class="{'animateX':isAnimateX && index == 0 && viewportWidth > 799,'animateRight':isAnimateX && index == 2 && viewportWidth > 799,'banner-fade-in':isAnimateX && index == 1 && viewportWidth > 799}"
            >
              <div class="img"><img loading="lazy"  :src="item.img" alt=""></div>
              <div class="bottom">
                <div class="level">Private small group</div>
                <div class="title">{{item.title}}</div>
                <div class="all-desc">
                  <div class="title-desc">{{item.titleDesc}}</div>
                  <div class="desc">{{item.desc}}</div>
                </div>
                <div class="btn">view details</div>
                <div class="time">{{item.time}}</div>
              </div>
            </div>
          </div>
          <div class="Popular-products-btn" @click="seeAllEvent">explore all itineraries</div>
        </div>
      </div>
      <div class="Case-Study">
      <div class="content-center">
        <div class="Case-Study-center" ref="videoPlayer">
          <div class="left" :class="{'animateX':videoPlayerAnimate && viewportWidth > 799}">
            <div class="top">
              <img loading="lazy"  src="../../../static/img/home/Layer_1.png" alt="">
            </div>
            <div class="center">{{CaseStudyInfo.desc}}</div>
            <div class="bottom">
              <div class="bottom-left">
                <img loading="lazy"  src="../../../static/img/home/Filled.png" alt="">
                <div class="desc1">{{CaseStudyInfo.desc1}}</div>
              </div>
              <div class="border" v-show="viewportWidth >= 799"></div>
              <div class="desc2">{{CaseStudyInfo.desc2}}</div>
            </div>
            <div class="btn" style="display:none">{{CaseStudyInfo.btn}}</div>
          </div>
          <div class="right" :class="{'animateRight':videoPlayerAnimate && viewportWidth > 799}">
             <div class="video">
              <div class="video-player" id="video-player" v-if="!isVideoFailed">
                <!-- <video ref="videoPlayer" width="100%" controls @play="onPlay" controlslist="nodownload">
                  <source :src="videoSource" type="video/mp4" />
                  Your browser does not support the video tag.
                </video> -->
                <!-- <iframe width="100%" height="318px"
                  src="https://www.youtube.com/embed/WeOF2S7W-5c?autoplay=1&vq=hd2160"
                  frameborder="1"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe> -->
              </div>
              <div class="video-player-img" v-if="isVideoFailed">
                <img loading="lazy"  src="../../../static/img/home/videoFailed.png" alt="">
                <div class="video-failed-info">Loading failed, please try again later...</div>
                </div>
              <div class="info" @click="togglePlay" v-show="isShow">
                <div class="play">
                  <img loading="lazy"  src="../../../static/img/home/circle-button.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="user-content" ref="userContent">
       <div class="background" v-show="viewportWidth >= 800">
          <div class="title" :class="{'animate':fadeIn}">
              “I've traveled with bbgmove several times, and each time has been a unique and unforgettable experience.
              Their team of travel specialists are knowledgeable, friendly, and always go the extra mile to make sure that everything
              and everyone is taken care of. I highly recommend bbgmove to anyone looking for a truly special travel experience!”
          </div>
          <div class="all-box-img">
            <div class="box-img" v-for="item in userList" :key="item.id" :class="'img'+item.id">
              <img loading="lazy"
                @mouseenter="isActive = item.id"
                @mouseleave="isActive = 0"
                :src="item.img" 
                alt="" 
                class="img4"
                :class="{'activeImg':isActive == item.id,'banner-fade-in':fadeIn}"
                @click="userEvent(item.id)">
              <div class="info" :class="{'animate': isActive == item.id}">
                <div class="name" v-show="item.name">{{item.name}}</div>
                <div class="adress" v-show="item.adress">{{item.adress}}</div>
              </div>
            </div>
          </div>
       </div>
        <div class="user-content-center" v-show="viewportWidth <= 799">
          <div class="background"></div>
            <div class="all-img-box">
              <div class="box-img" v-for="item in userList" :key="item.id" :class="'img'+item.id">
                <img loading="lazy"
                  :src="item.img" 
                  alt="" 
                  class="img4"
                  :class="{'activeImg':isActive == item.id,'banner-fade-in':fadeIn}"
                  @click="userEvent(item.id)">
            </div>
        </div>
        <div class="info">
          <div class="name" v-show="userInfo.name">{{userInfo.name}}</div>
          <div class="adress" v-show="userInfo.adress">{{userInfo.adress}}</div>
        </div>
        <div class="title" :class="{'animate':fadeIn}">
            “I've traveled with bbgmove several times, and each time has been a unique and unforgettable experience.
            Their team of travel specialists are knowledgeable, friendly, and always go the extra mile to make sure that everything
            and everyone is taken care of. I highly recommend bbgmove to anyone looking for a truly special travel experience!”
        </div>
      </div>
    </div>
    <div class="start-your-travel" ref="startYourTravel">
      <div class="content-center-start" :class="{'banner-fade-in':animate}">
          <div class="content-background">
              <div class="info-center">
                <div class="top" :class="{'animate':animate}">{{startYourTravelInfo.title}}</div>
                <div class="center" :class="{'animate':animate}">
                  {{startYourTravelInfo.desc}}
                </div>
              <div class="bottom" @click="startYourTravelEvent" :class="{'animate':animate}">
                <div class="btn">{{startYourTravelInfo.btn}}</div>
                <img loading="lazy"  src="../../../static/img/home/back.png" alt="">
              </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import homeInfo from '/js/home/home.js'
// import travelVideo from '../../../static/video/BBGMOVE.mp4'
import Rectangle from '/static/img/home/world/Rectangle.png'
import RectanglePhone from '/static/img/home/world/Rectangle1.png'
import experiences from '/js/home/experiences.js'
import popularProducts from '/js/home/popularProducts.js'
export default {
     data() {
      return {
        Rectangle:Rectangle,
        RectanglePhone:RectanglePhone,
        experiencesList:experiences.experiencesList,
        allProductsList:popularProducts.popularProductsList,
        productsList:popularProducts.popularProductsList.slice(0, 3),
        isFadingIn: false, // 用于控制淡入动画
        specialOffersList:[],
        navList:[],
        selectedId: 1, // 默认选中第一个项,
        explorePopularList:[],
        newExplorePopularList:[],
        CaseStudyInfo:{},
        startYourTravelInfo:{},
        isActive:0,
        // videoSource:travelVideo,

        isShow:true,
        youTubePlayer:{},
        userList:[],
        userInfo:{
          name:'',
          adress:''
        },
        isVideoFailed:false,
        isAnimateX:false,
        isAnimateShow:false,
        fadeIn:false,
        animate:false,
        videoPlayerAnimate:false,
        isExperiencesAnimate:false,
        isWorldAnimate:false,
        viewportWidth:0
      };
    },
    created(){
      this.specialOffersList = homeInfo.specialOffersList
      this.explorePopularList = homeInfo.explorePopularList
      this.newExplorePopularList = this.explorePopularList.slice(0, 4)
      this.CaseStudyInfo = homeInfo.CaseStudyInfo
      this.startYourTravelInfo = homeInfo.startYourTravelInfo
      this.navList = homeInfo.navList
      this.userList = homeInfo.userList
    },
     mounted() {
      this.viewportWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
       // 创建 IntersectionObserver 实例并观察两个元素
      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // 根据 entry.target 判断是哪个元素触发了观察
            if (entry.isIntersecting) {
              if (entry.target === this.$refs.world) {
                this.isWorldAnimate = true
              }else if (entry.target === this.$refs.popularProducts) {
                // 如果 .Popular-products 元素进入视口，执行对应的动画
                this.isAnimateX = true;
                this.$al // 执行动画的逻辑
              } else if (entry.target === this.$refs.userContent) {
                // 如果 .userContent 元素进入视口，执行不同的动画
                this.fadeIn = true
              }else if (entry.target === this.$refs.startYourTravel) {
                this.animate = true
              }else if (entry.target === this.$refs.videoPlayer) {
                this.videoPlayerAnimate = true
              }else if (entry.target === this.$refs.experiences) {
                this.isExperiencesAnimate = true
              }

              // 停止观察，确保动画只触发一次
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 }); // 触发时，至少 10% 的元素进入视口
        observer.observe(this.$refs.popularProducts); // 观察 Popular-products 元素
        observer.observe(this.$refs.userContent); // 观察 userContent 元素
        observer.observe(this.$refs.startYourTravel); // 观察 userContent 元素
        observer.observe(this.$refs.videoPlayer); // 观察 userContent 元素
        observer.observe(this.$refs.experiences); // 观察 userContent 元素
        observer.observe(this.$refs.world); // 观察 userContent 元素
        // 解决window.YT.Player异步加载
        if(window.YT){
          if(window.YT.Player){
            this.createPlayer();
          }else{
            // 监听 youtube-api-ready 事件
            window.addEventListener('youtube-api-ready', this.createPlayer);
          }
        }else{
          this.isVideoFailed = true
        }
    },
    beforeDestroy() {
      // 组件销毁时移除事件监听器
      window.removeEventListener('youtube-api-ready', this.createPlayer);
      window.removeEventListener('resize', this.handleResize);
    },
    methods:{
      handleResize() {
        this.viewportWidth = window.innerWidth;
      },
      experiencesEvent(id){
        if(id == 2){
          this.$router.push({
            path:'/experience/activities?navId=3'
          })
        }else if(id == 1){
          this.$router.push({
            path:'/experience/services?navId=4'
          })
        }
      },
      seeAllEvent() {
        // if (this.allProductsList.length > this.productsList.length) {
        //   // 获取从第 3 个开始的剩余产品
        //   let remainingProducts = this.allProductsList.slice(3);
        //   // 将所有 visibleItems 中的项标记为 fadeIn: false
        //   this.productsList = this.productsList.map(item => ({
        //     ...item,
        //     fadeIn: false
        //   }));
        //   // 标记剩余的产品为 fadeIn: true
        //   remainingProducts = remainingProducts.map(item => ({
        //     ...item,
        //     fadeIn: true
        //   }));
        //   // 一次性加载剩余的产品
        //   this.productsList = this.productsList.concat(remainingProducts);
        // } else {
        //   this.$message({
        //     showClose: true,
        //     message: 'No more data available at the moment !'
        //   });
        // }
        this.$router.push({
          path:'/travel'
        })
      },
      createPlayer() {
        this.youTubePlayer = new window.YT.Player('video-player', {
            height: '100%',
            width: '100%',
            videoId: 'WeOF2S7W-5c', // YouTube 视频 ID
                playerVars: {
                    vq: 'hd2160', // 尝试强制 4K（不一定生效）
                },
        });
     },
      productDetilsEvent(id){
        this.$router.push({
          path:'/productDetails',
          query:{id:`${id}`}
        })
      },
      bookNowEvent(){
        this.$router.push({
          path:'/bookNow',
        })
      },
      selectItem(id) {
        this.selectedId = id; // 更新选中的项
        if(id == 1){
          this.newExplorePopularList = this.explorePopularList.slice(0, 4)
        }else if(id == 2){
          this.newExplorePopularList = this.explorePopularList.slice(0, 4)
        }else if(id == 3){
          this.newExplorePopularList = this.explorePopularList.slice(4, 8)
        }else if(id == 4){
          this.newExplorePopularList = this.explorePopularList.slice(8, 12)
        }else if(id == 5){
          this.newExplorePopularList = this.explorePopularList.slice(12, 16)
        }
      },
       togglePlay() {
          this.isShow = false;
          console.log(this.youTubePlayer)
          if(JSON.stringify(this.youTubePlayer) != '{}'){
            this.youTubePlayer.playVideo();
          }
      },
      userEvent(val){
        this.isActive = val
        this.userList.forEach(item=>{
          if(item.id == val){
            this.userInfo = item
          }
        })
      },
      startYourTravelEvent(){
        this.$router.push({
          path:'/bookNow',
        })
      }
    }
}
</script>
<style lang="scss" scoped>
 @import '/style/pc/home/home.scss';
 @import '/style/pc/common/animateX.scss';
 @import '/style/pc/common/animateRight.scss';
 @import '/style/pc/common/fadeIn.scss';
  @import '/style/pc/common/animate.scss';
  @import '/style/phone/home/home.scss';
</style>

